// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { xScreen } from "@guestsupply/XDL/Utilities";
import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

sortSelectStyles.select = {
    labelProps: {
        size: 14,
        weight: 400,
        css: css`
            width: unset;
            padding-top: 2px;
            padding-right: 8px;
            text-transform: none;
            ${xScreen("lte", "md")} {
                padding-top: 0;
                font-size: 12px;
                font-weight: 500;
            }
        `,
    },
    cssOverrides: {
        formField: css`
            width: auto;
            ${xScreen("lte", "md")} {
                width: 100%;
                padding-left: 16px;
            }
        `,
        inputSelect: css`
            width: 147px;
            height: 28px;
            display: block;
            ${xScreen("lte", "md")} {
                height: 36px;
                width: 100%;
            }
        `,
        formInputWrapper: css`
            width: 147px;
            ${IconWrapper} {
                svg {
                    width: 9px;
                }
            }
            ${xScreen("lte", "md")} {
                width: auto;
            }
        `,
    },
    iconProps: {
        css: css`
            &&& {
                height: 24px;
                width: 24px;
                top: 4px;
                ${xScreen("lte", "md")} {
                    height: 32px;
                }
            }
        `,
    },
};
